import { createAction } from 'redux-actions'
import { createRequestActions as request } from 'store/actionCreators'

export const getActivities = request('ACTIVITIES/GET', ({ protrackId, levelId }) => ({
  request: {
    url: `/protracks/${protrackId}/protracks-levels/${levelId}/activities`,
  },
}))

export const triggerPostActivitiesList = createAction(
  'ACTIVITIES/TRIGGER_POST_ACTIVITIES_LIST',
  (data, shouldLeavePage = true) => ({
    data,
    shouldLeavePage,
  })
)

export const patchActivitiesList = request(
  'ACTIVITIES/PATCH_ACTIVITIES_LIST',
  ({ values, protrackId, levelId, shouldLeavePage }) => ({
    request: {
      url: `/protracks/${protrackId}/protracks-levels/${levelId}/activities`,
      method: 'PATCH',
      data: values,
    },
    shouldLeavePage,
  })
)

export const postActivitiesListBulk = request(
  'ACTIVITIES/POST_ACTIVITIES_LIST_BULK',
  ({ values, protrackId, levelId, shouldLeavePage }) => ({
    request: {
      url: `/protracks/${protrackId}/protracks-levels/${levelId}/activities/bulk`,
      method: 'POST',
      data: values,
    },
    shouldLeavePage,
    proTrackId: protrackId,
    levelId,
  })
)

export const postActivity = request('ACTIVITIES/POST', ({ values, protrackId, levelId, tempId }) => ({
  request: {
    url: `/protracks/${protrackId}/protracks-levels/${levelId}/activities`,
    method: 'POST',
    data: values,
  },
  tempId,
}))

export const putActivity = request('ACTIVITIES/PUT', ({ values, protrackId, levelId, activityId }) => ({
  request: {
    url: `/protracks/${protrackId}/protracks-levels/${levelId}/activities/${activityId}`,
    method: 'PUT',
    data: values,
  },
}))

export const setView = createAction('ACTIVITIES/SET_VIEW', id => ({ id }))

export const setOrder = createAction('ACTIVITIES/SET_ORDER', (list, oldIndex, newIndex) => ({
  list,
  oldIndex,
  newIndex,
}))

export const setDeleted = createAction('ACTIVITIES/SET_DELETED', (id, isDeleting) => ({
  id,
  isDeleting,
}))

export const setBeforeCreateOrder = createAction('ACTIVITIES/SET_BEFORE_CREATE_ORDER', day => ({ day }))

export const setPinned = createAction('ACTIVITIES/SET_PINNED', (id, isPinned) => ({
  id,
  isPinned,
}))

export const deleteTempActivity = createAction('ACTIVITIES/DELETE_TEMP', id => ({ id }))

export const templateFileChange = createAction('ACTIVITIES/TEMPLATE_FILE_INPUT_CHANGE', data => ({ data }))

export const addActivitiesFromFile = createAction('ACTIVITIES/FILL_ALL', activities => ({ data: activities }))

export const addActivityToExamples = request('ACTIVITIES/ADD_TO_EXAMPLES', ({ activityId, proTrackId, levelId }) => ({
  request: {
    url: `/protracks/${proTrackId}/protracks-levels/${levelId}/activities/${activityId}/examples`,
    method: 'POST',
  },
}))

export const removeActivityFromExamples = request(
  'ACTIVITIES/REMOVE_FROM_EXAMPLES',
  ({ activityId, proTrackId, levelId }) => ({
    request: {
      url: `/protracks/${proTrackId}/protracks-levels/${levelId}/activities/${activityId}/examples`,
      method: 'DELETE',
    },
  })
)

export const fetchCategoriesTagsForProTrackLevel = request(
  'ACTIVITIES/FETCH_CATEGORIES_TAGS_FOR_PROTRACK_LEVEL',
  ({ proTrackId, levelId }) => ({
    request: {
      url: `/protracks/${proTrackId}/protracks-levels/${levelId}/categories-tags`,
    },
  })
)

export const uploadActivityImage = createAction(
  'ACTIVITIES/UPLOAD_ACTIVITY_IMAGE_REQUEST',
  (file, fileResolution, imageDomainId, s3Entity, mime, canvasFileName) => ({
    file,
    fileResolution,
    imageDomainId,
    s3Entity,
    mime,
    canvasFileName,
  })
)

export const updateActivityImage = createAction('ACTIVITIES/UPDATE_ACTIVITY_IMAGE', (id, image) => ({ id, image }))

export const trigerShowModalsWithImageCropper = createAction(
  'ACTIVITIES/TRIGER_SHOW_MODALS_WITH_IMAGE_CROPPER',
  (arrOfImageForCropp, lengthOfFileList, lengthOfErrorList, imageInputProps) => ({
    arrOfImageForCropp,
    lengthOfFileList,
    lengthOfErrorList,
    imageInputProps,
  })
)
